import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const features = [
  ['Autentificare și conturi', 'Înregistrare, autentificare, profil personal și gestionarea sesiunii.', 'Disponibil'],
  ['Catalog digital', 'Căutare și explorare a cărților după titlu, autor, categorie, an și limbă.', 'Disponibil'],
  ['Căutare avansată', 'Filtre combinate și rezultate organizate pentru identificarea rapidă a resurselor.', 'Disponibil'],
  ['Cititor digital', 'Previzualizare și lectură în browser pentru conținutul disponibil.', 'Disponibil'],
  ['Adnotări și marcaje', 'Evidențieri, notițe și marcaje personale în timpul lecturii.', 'Disponibil'],
  ['Favorite și colecții', 'Salvarea cărților preferate și organizarea lor în colecții personale.', 'Disponibil'],
  ['Evaluări și recenzii', 'Acordarea de calificative, recenzii și răspunsuri pentru cărți.', 'Disponibil'],
  ['Recomandări personalizate', 'Recomandări bazate pe preferințele și istoricul de lectură al utilizatorului.', 'Disponibil'],
  ['Resurse educaționale', 'Acces la resurse pentru clasele I–VIII, diverse discipline și resurse interactive.', 'Disponibil'],
  ['Blog și conținut editorial', 'Articole, categorii, etichete și conținut editorial administrabil.', 'Disponibil'],
  ['Panou de administrare', 'Administrarea utilizatorilor, cărților, colecțiilor, contactului și conținutului.', 'Disponibil'],
  ['Accesibilitate', 'Controale pentru contrast, dimensiunea textului, citire vocală și navigare asistată.', 'Disponibil']
];

const ExtendedFeaturesPage: React.FC = () => (
  <div className="flex flex-col min-h-screen bg-gray-50">
    <Header />
    <div className="pt-24 md:pt-28" />

    <main className="flex-grow">
      <section className="bg-gradient-to-br from-blue-700 to-blue-900 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <p className="text-blue-200 font-semibold uppercase tracking-wide mb-3">Instanța demonstrativă</p>
          <h1 className="text-4xl md:text-5xl font-bold mb-5">Matricea funcționalităților extinse</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Prezentarea funcționalităților disponibile în Biblioteca Digitală pentru verificarea instanței demonstrative.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">Funcționalități disponibile</h2>
              <p className="mt-2 text-gray-600">
                Matricea poate fi consultată permanent din zona de footer a instanței demonstrative.
              </p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead className="bg-blue-50 text-blue-900">
                  <tr>
                    <th className="px-6 py-4 font-bold">Funcționalitate</th>
                    <th className="px-6 py-4 font-bold">Descriere</th>
                    <th className="px-6 py-4 font-bold whitespace-nowrap">Stare</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {features.map(([name, description, status]) => (
                    <tr key={name} className="hover:bg-gray-50">
                      <td className="px-6 py-4 font-semibold text-gray-900 whitespace-nowrap">{name}</td>
                      <td className="px-6 py-4 text-gray-600">{description}</td>
                      <td className="px-6 py-4">
                        <span className="inline-flex rounded-full bg-green-100 px-3 py-1 text-sm font-semibold text-green-800">
                          {status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default ExtendedFeaturesPage;
